export default __webpack_public_path__ + "static/media/Unamused.a932ee00.svg";